<template>
<div class="chapter">
<div class="inner_page">
<p class="epigraph" style="margin-top:3em; text-align:center;"><a id="page_x"><em>Plato says: One is not even one, two is one hardly</em>.</a></p><a id="page_x">
<p class="attribute" style="margin-top:0.5em; text-align:center;"><em>Theopompus fr. 15K</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226670393_06_epi.vue?27b02b3a